import Options from './module'
// eslint-disable-next-line
const {default:items} = require('@/lib/options/index')

Options.injectOptionsLib(items as Options[], Options.lib)

export default Options
